import Fetch from './index'

const json = (body) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
})

// Company-level MCP Servers
export const getMCPServers = () => Fetch('/mcp-server/')

export const getMCPServer = (id) => Fetch(`/mcp-server/${id}`)

export const createMCPServer = (body) => Fetch('/mcp-server/', json(body))

export const updateMCPServer = (id, body) =>
  Fetch(`/mcp-server/${id}`, { ...json(body), method: 'PUT' })

export const deleteMCPServer = (id) =>
  Fetch(`/mcp-server/${id}`, { method: 'DELETE' })

export const getMCPServerTools = (id) => Fetch(`/mcp-server/${id}/tools`)

export const startMCPOAuth = (id) => Fetch(`/mcp-server/${id}/oauth/start`)

export const completeMCPOAuth = (body) =>
  Fetch('/mcp-server/oauth/callback/complete', json(body))

// Assistant-level bindings
export const getAssistantMCPServers = (assistantId) =>
  Fetch(`/assistant/${assistantId}/mcp-server`)

export const createAssistantMCPServer = (assistantId, body) =>
  Fetch(`/assistant/${assistantId}/mcp-server`, json(body))

export const updateAssistantMCPServer = (assistantId, bindId, body) =>
  Fetch(`/assistant/${assistantId}/mcp-server/${bindId}`, {
    ...json(body),
    method: 'PUT',
  })

export const deleteAssistantMCPServer = (assistantId, bindId) =>
  Fetch(`/assistant/${assistantId}/mcp-server/${bindId}`, { method: 'DELETE' })

export const updateAssistantMCPServerTools = (assistantId, bindId, tools) =>
  Fetch(`/assistant/${assistantId}/mcp-server/${bindId}/tools`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(tools),
  })
